module.exports = __webpack_public_path__ + "img/panama.8db7e0df.jpg";